import { Tooltip } from "@stacklet/ui";

import { useHasScopePermission } from "app/hooks";

import { CreateNonSsoUser } from "../users/user-list/components/actions/CreateNonSsoUser";

export function UsersActionBar() {
  const hasPermission = useHasScopePermission();
  const hasSystemEditPermission = hasPermission("system", "EDIT");

  return (
    // Search lives in the directory below (per view), so the bar holds just the
    // create action, aligned to the right.
    <div className="mb-6 flex items-center justify-end">
      <Tooltip
        title={
          hasSystemEditPermission
            ? ""
            : "You need system edit permissions to create a user"
        }
        asChild
      >
        <span>
          <CreateNonSsoUser />
        </span>
      </Tooltip>
    </div>
  );
}
